export enum DeployStatus {
  DEPLOYING = 'deploying',
  DEPLOYED = 'deployed',
  FAILED = 'failed',
  SUCCESS = 'success',
  ADOPTED = 'adopted',
  ADOPTING = 'adopting',
  // Terminated instances will be permanently deleted so this state will most likely not exist
  TERMINATED = 'terminated',
  TERMINATING = 'terminating',
  TERMINATION_FAILED = 'termination_failed',
  CONFIGURING = 'configuring',
  CONFIGURED = 'configured',
  CONFIGURATION_FAILED = 'configuration_failed',

  NOT_DEPLOYED = 'not deployed',
  UPDATING = 'updating',
  UPDATED = 'updated',
  UPDATE_FAILED = 'update_failed',
  TESTING = 'testing',
  TESTED = 'tested',
  TEST_FAILED = 'test_failed',
  FAILOVER_APPLYING = 'failover_applying',
  FAILBACK_APPLYING = 'failback_applying',
  PRE_FAILBACK_APPLYING = 'pre_failback_applying',
  FAILOVER_FAILED = 'failover_failed',
  FAILBACK_FAILED = 'failback_failed',
  PRE_FAILBACK_FAILED = 'pre_failback_failed',
  POST_FAILBACK_APPLYING = 'post_failback_applying',
  POST_FAILBACK_FAILED = 'post_failback_failed',
  STARTING_AGENT = 'starting_agent',
  STOPPING_AGENT = 'stopping_agent',
  STARTING = 'starting',
  STARTED = 'started',
  START_FAILED = 'start_failed',
  STOPPING = 'stopping',
  STOPPED = 'stopped',
  STOP_FAILED = 'stop_failed',
  INPROGRESS = 'inprogress',
  OPERATION_INPROGRESS = 'operation_inprogress',
  TENANT_AGENT_CREATION_IN_PROGRESS = 'Tenant Agent Creation in progress',
  COB_NOT_STARTED = 'not started',
  INITIALIZING = "initializing",
  INITIALIZED = "initialized",
  INITIALIZE_FAILED = "initialize_failed",
  DELETED = "deleted",
  DELETE_FAILED = "delete_failed",
  DELETION_FAILED = "deletion_failed",
  DELETING = "deleting",
  ENABLED = "enabled",
  ENABLING = "enabling",
  ENABLE_FAILED = 'enable_failed',
  DISABLED = "disabled",
  DISABLING = "disabling",
  DISABLE_FAILED = "disable_failed",
  COMPLETED = "completed",
  REMOVED = "removed",
  REMOVING_FAILED = "removing_failed",
  REMOVING = "removing",
  FALLBACK_INPROGRESS = "fallback_inprogress",
  FAILOVER_INPROGRESS = "failover_inprogress",
  PROVISIONING = "provisioning",
  RESTORING = "restoring",
  RESIZING = "resizing",
  ABORTING = "aborting"
}

export const deployStatuses = Object.values(DeployStatus);
